import React, { Component }  from 'react'
import { Segment, Table, Input, Confirm, Button, Icon, Modal, Dropdown, Form } from 'semantic-ui-react'

import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'

import PaginationTable from '../../components/PaginationTable/PaginationTable'

// The 2016 SHS curriculum splits subjects by semester. Strengthened SHS
// (Grade 11, DM 012 s. 2026) has no semesters - the same field marks which
// TERM an elective runs in, which is what the Grade 11 report card reads to
// place its three elective rows. Both need the column visible; only the label
// differs.
const SEMESTER_LEVEL_TYPES = ['SHSHUMSS', 'SHSSTEM', 'SHSABM'];
const TERM_LEVEL_TYPES = ['SHSACAD', 'SHSTECHPRO'];

const usesTerms = (levelType) => TERM_LEVEL_TYPES.indexOf(levelType) !== -1;
const showsPeriodColumn = (levelType) =>
  usesTerms(levelType) || SEMESTER_LEVEL_TYPES.indexOf(levelType) !== -1;
const periodLabel = (levelType) => (usesTerms(levelType) ? 'Term' : 'Semester');

const _ = {
  sortBy: sortBy,
  find: find,
  groupBy: groupBy,
  isEmpty: isEmpty
}

class SectionSubjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      levelType: 'JHS',
      searchKey: '',
      fields: ['name', 'actions'],
      activePage: 1,
      itemPerPage: 6,
      selectedIndex: 0,
      column: null,
      direction: null,
      open: false,
      subjectName: '',
      id: '',
      sectionId: '',
      optionsTeachers: [],
      teacherId: '',
      sem: '',
      editOpen: false
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  open = (subjectName, id, sectionId) => this.setState({ open: true, subjectName, id, sectionId })
  close = () => this.setState({ open: false })

  openEdit = (subjectName, id, sectionId, teacherId) => this.setState({ editOpen: true, subjectName, id, sectionId, teacherId })
  closeEdit = () => this.setState({ editOpen: false })

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.subject.name.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      if (clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, function(o){return o.subject.name}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }

    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleDelete() {
    this.setState({ open: false })
    this.props.handleDeleteSectionSubject(this.state.id, this.state.sectionId)
  }

  handleUpdate() {
    this.setState({ editOpen: false })
    this.props.handleUpdateSectionSubject(this.state.sectionId, this.state.teacherId, this.state.id, this.state.sem);
  }

  componentDidMount() {
    this.setState({data: this.props.sectionSubjects, levelType: this.props.levelType, optionsTeachers: this.props.optionsTeachers})
  }

  componentWillReceiveProps(newProps) {
    this.setState({data: newProps.sectionSubjects, levelType: newProps.levelType, optionsTeachers: this.props.optionsTeachers})
  }

  render() {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, optionsTeachers, levelType } = this.state;
    if(_.isEmpty(data)) return null;

    let currentData = data.filter(this.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const subjectsTable = currentData.map((sectionSubject, key )=> {
      const teacherName = sectionSubject.teacher ? 
        sectionSubject.teacher.firstName + ' ' + sectionSubject.teacher.lastName : 
        'No Teacher Assigned'
      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{sectionSubject.subject.name}</Table.Cell>
          <Table.Cell>{teacherName}</Table.Cell>
          { showsPeriodColumn(levelType) ?
            <Table.Cell>{sectionSubject.sem}</Table.Cell>:
            null
          }
          <Table.Cell collapsing>
            <Button icon size='tiny' onClick={()=>this.openEdit(sectionSubject.subject.name, sectionSubject.sectionSubjectId, sectionSubject.sectionId, sectionSubject.teacher ? sectionSubject.teacherId : '' )}>
              <Icon name='pencil' />
            </Button>
            <Button icon size='tiny' onClick={()=>this.open(sectionSubject.subject.name, sectionSubject.sectionSubjectId, sectionSubject.sectionId)}>
              <Icon name='trash' />
            </Button>
          </Table.Cell>
        </Table.Row>
      );
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            rowSpan='2'
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => this.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Teacher</Table.HeaderCell>
          { showsPeriodColumn(levelType) ?
            <Table.HeaderCell textAlign='center'>{periodLabel(levelType)}</Table.HeaderCell>:
            null
          }
          <Table.HeaderCell textAlign='center'>Actions</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )



    let confirmContent = `Are you sure you want to remove ${this.state.subjectName} in this section?`;

    return (
      <div className='table-sections'>
        <Input
          icon='search'
          fluid
          value={searchKey}
          onChange={this.onSearchChange}
          className='section-students-search'
          placeholder='Search Subjects'
        />
        {
          data.length > 0 ?
          <Table celled sortable striped compact size='small'>
            {headers}

            <Table.Body>{subjectsTable}</Table.Body>
              {
                data.length > itemPerPage ?
                <PaginationTable
                  onPageChange={this.handlePaginationChange}
                  totalPages={totalPages}
                  activePage={activePage}
                  fields={fields}
                >

                </PaginationTable>
                :
                null
              }
          </Table>
          :
          <Segment>No subject records found.</Segment>
        }
        <Confirm content={confirmContent} open={this.state.open} onCancel={this.close} onConfirm={this.handleDelete} />

        <Modal
          open={this.state.editOpen}
          size='small'
          onClose={this.closeEdit}
          closeIcon
        >
          <Modal.Content>
            <h3>Change teacher for this subject: <strong>{this.state.subjectName}</strong> </h3>
            <Dropdown
              search
              selection
              fluid
              name='teacherId'
              placeholder='Teachers'
              className='teacher-dropdown'
              options={optionsTeachers}
              onChange={this.handleChange}
              value={this.state.teacherId}
            />
            <Form.Field
              control={Input}
              value={this.state.sem}
              name='sem'
              label={periodLabel(levelType)}
              placeholder={usesTerms(levelType)
                ? 'Term the subject runs in, e.g. 1 for an elective, 1,2,3 for a whole-year subject'
                : 'Semester'}
              onChange={this.handleChange}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button color='green' onClick={this.handleUpdate}>
              <Icon name='checkmark' /> Update Section
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
};

export default SectionSubjects;
